import { identifyUser } from '../../analytics/analytics-bridge';
import { resolveIdentityInput } from '../../analytics/identity-input';
import { getLocale } from '../../http/auth-storage';
import { getTenantStorage } from './tenant-storage';
import { getLoggedUser } from './user-storage';

/**
 * Identifica o usuário a partir da sessão persistida. Serve tanto à entrada das telas
 * privadas quanto à conclusão de uma troca de conta: o storage é lido no momento da chamada,
 * então o tenant é sempre o mais recente, inclusive em duas trocas seguidas. Nunca lança.
 */
export function identifyFromSession(): void {
  try {
    const input = resolveIdentityInput({
      user: getLoggedUser(),
      tenant: getTenantStorage(),
      locale: getLocale(),
    });
    if (input) {
      identifyUser(input);
    }
  } catch {
    // Telemetria é melhor-esforço: falhar aqui não pode afetar a tela nem a troca de conta.
  }
}
